import type {ReactElement} from 'react';
import React from 'react';
import {Label} from '@Components/label';
import {TIME_BLOCK_ALIGNMENT} from '@Panels/trim-panels/trim-panels.types';
import type {DurationCallback} from '@Components/duration-input/duration-input.types';
import ControlledDurationInput from '@Components/controlled-duration-input/controlled-duration-input';
import styles from './time-block.module.scss';

export interface TimeBlockProps {
  label: string;
  seconds: number;
  maxTime: number;
  minTime: number;
  callback: DurationCallback;
  idDuration: string;
  alignment: TIME_BLOCK_ALIGNMENT;
}

export function TimeBlock({...props}: TimeBlockProps): ReactElement {
  return (
    <div className={`flex-v-row ${props.alignment === TIME_BLOCK_ALIGNMENT.ALIGNLEFT ? styles.leftAlign : styles.rightAlign}`}>
      <Label text={props.label} isBold htmlFor={props.idDuration} noMargin={props.alignment === TIME_BLOCK_ALIGNMENT.ALIGNRIGHT} />
      <ControlledDurationInput id={props.idDuration} duration={props.seconds} maxDuration={props.maxTime} minDuration={props.minTime} onDurationChanged={props.callback} />
    </div>
  );
}
